import React from 'react'
import { Grid } from '@material-ui/core'
import "./description-template.css";

const DescriptionTemplatePure = ({description}) => {
  return (
    <div className="descriptionTemplatePure-container">
      <p className="descriptionTemplatePure-description">{description}</p>
    </div>
    )
  }

export { DescriptionTemplatePure as default }
